import React from 'react'

export const Trade = () => {
  return (
    <div>Trade</div>
  )
}
